<template>
  <!-- main view halaman -->
  <section style="margin-top: 70px; background: none">
    <!-- sekilas info dan grafik presensi -->
    <div class="sekilas-info-grafik-presensi">
      <!-- filter dan grafik presensi -->
      <div style="flex-direction:row" class="filter-dan-grafik">
        <!-- filter -->
        <div class="filter">
          <h5>Filter</h5>
          <!-- input cabang -->
          <div style="position: relative" class="keterangan">
            <div
              @click="openClosePilihanCabangPresensi(true)"
              class="box-form email"
            >
              <svg
                width="14"
                height="18"
                viewBox="0 0 14 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M13.4284 7.57115C13.4284 12.5712 6.99986 16.8569 6.99986 16.8569C6.99986 16.8569 0.571289 12.5712 0.571289 7.57115C0.571289 5.86619 1.24858 4.23105 2.45417 3.02546C3.65976 1.81987 5.2949 1.14258 6.99986 1.14258C8.70482 1.14258 10.34 1.81987 11.5455 3.02546C12.7511 4.23105 13.4284 5.86619 13.4284 7.57115Z"
                  stroke="#A0A3BD"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M6.99986 9.71401C8.18333 9.71401 9.14272 8.75462 9.14272 7.57115C9.14272 6.38768 8.18333 5.42829 6.99986 5.42829C5.81639 5.42829 4.857 6.38768 4.857 7.57115C4.857 8.75462 5.81639 9.71401 6.99986 9.71401Z"
                  stroke="#A0A3BD"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>

              <div class="input-and-title">
                <span
                  v-if="filterPresensi.cabang"
                  style="display: block"
                  class="input-title"
                  >Cabang</span
                >
                <p>
                  {{ filterPresensi.cabang ? filterPresensi.cabang : "Cabang" }}
                </p>
              </div>
            </div>
            <!-- box pilihan keterangan -->
            <div
              style="display: none"
              ref="pilihan-cabang-presensi"
              class="box-pilihan"
            >
              <p
                :key="cabang"
                v-for="cabang in listPenempatan"
                @click="openClosePilihanCabangPresensi(false, cabang)"
              >
                {{ cabang }}
                <svg
                  v-if="cabang === filterPresensi.cabang"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M15.7142 5.71484L7.85707 13.572L4.28564 10.0006"
                    stroke="#00BA88"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </p>
            </div>
            <!-- end of box pilihan cabang -->
          </div>
          <!-- end of input cabang -->

          <!-- input divisi -->
          <div style="position: relative" class="keterangan">
            <div
              @click="openClosePilihanDivisiPresensi(true)"
              class="box-form email"
            >
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M0.857422 11.5717L8.00028 15.1431L15.1431 11.5717M0.857422 8.00028L8.00028 11.5717L15.1431 8.00028M8.00028 0.857422L0.857422 4.42885L8.00028 8.00028L15.1431 4.42885L8.00028 0.857422Z"
                  stroke="#A0A3BD"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>

              <div class="input-and-title">
                <span
                  v-if="filterPresensi.divisi"
                  style="display: block"
                  class="input-title"
                  >Divisi</span
                >
                <p>
                  {{ filterPresensi.divisi ? filterPresensi.divisi : "Divisi" }}
                </p>
              </div>
            </div>
            <!-- box pilihan divisi -->
            <div
              style="display: none"
              ref="pilihan-divisi-presensi"
              class="box-pilihan"
            >
              <p
                :key="divisi"
                v-for="divisi in listDivisi.slice(0, -1)"
                @click="openClosePilihanDivisiPresensi(false, divisi)"
              >
                {{ divisi }}
                <svg
                  v-if="divisi === filterPresensi.divisi"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M15.7142 5.71484L7.85707 13.572L4.28564 10.0006"
                    stroke="#00BA88"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </p>
            </div>
            <!-- end of box pilihan divisi -->
          </div>
          <!-- end of input divisi -->

          <!-- input tanggal -->
          <label tabindex="0" for="date-picker-lahir" class="box-form email">
            <svg
              width="14"
              height="16"
              viewBox="0 0 14 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M9.85725 0.857422V3.71456M4.14296 0.857422V3.71456M0.571533 6.57171H13.4287M2.0001 2.28599H12.0001C12.7891 2.28599 13.4287 2.92559 13.4287 3.71456V13.7146C13.4287 14.5035 12.7891 15.1431 12.0001 15.1431H2.0001C1.21113 15.1431 0.571533 14.5035 0.571533 13.7146V3.71456C0.571533 2.92559 1.21113 2.28599 2.0001 2.28599Z"
                stroke="#A0A3BD"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            <div style="position: relative" class="input-and-title">
              <input
                style="width: 200px; height: 50px"
                id="date-picker-lahir"
                class="date-control"
                type="date"
                v-model="filterPresensi.tanggal"
              />
              <p>
                {{
                  filterPresensi.tanggal ? filterPresensi.tanggal : "Tanggal"
                }}
              </p>
            </div>
          </label>
          <!-- end of input tanggal -->
        </div>
        <!-- end of filter -->

        <!-- grafik -->
        <div class="grafik-presensi">
          <div class="grafik-title">
            <h5>Grafik Presensi</h5>
            <svg
              @click="openCloseFilterPresensi"
              width="20"
              height="19"
              viewBox="0 0 20 19"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M18.5714 1.28564H1.42859L8.28573 9.39422V15.8571L11.7143 17.5714V9.39422L18.5714 1.28564Z"
                stroke="#4E4B66"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>

          <div style="flex-direction: row" class="grafik-tooltip">
            <GrafikPresensi
              :divisi="filterPresensi.divisi"
              :tanggal="filterPresensi.tanggal"
              :cabang="filterPresensi.cabang"
              style="width: 160px; height: 160px; margin-right: 18px"
            ></GrafikPresensi>
            <!-- tooltip -->
            <div class="tooltip">
              <p>
                <svg
                  width="8"
                  height="8"
                  viewBox="0 0 8 8"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle cx="4" cy="4" r="4" fill="#FFB700" />
                </svg>
                <span>Hadir</span>
              </p>
              <p>
                <svg
                  width="8"
                  height="8"
                  viewBox="0 0 8 8"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle cx="4" cy="4" r="4" fill="#F37D34 " />
                </svg>
                <span>Sakit, Izin</span>
              </p>
              <p>
                <svg
                  width="8"
                  height="8"
                  viewBox="0 0 8 8"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle cx="4" cy="4" r="4" fill="#EB5757" />
                </svg>
                <span>Alpha</span>
              </p>
            </div>
            <!-- end of tooltip -->
          </div>
        </div>
        <!-- end of grafik -->
      </div>
      <!-- end of filter dan grafik presensi -->
    </div>
    <!-- end of sekilas info dan grafik presensi -->

    <!-- filter presensi khusus mobile -->
    <div style="bottom: -100%" ref="filter-presensi-mobile" class="backdrop">
      <div class="filter-mobile">
        <div class="filter-mobile-title">
          <h5>Filter Grafik Presensi</h5>
          <!-- close filter -->
          <svg
            @click="openCloseFilterPresensi"
            width="10"
            height="10"
            viewBox="0 0 10 10"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M9.28566 0.714355L0.714233 9.28578M0.714233 0.714355L9.28566 9.28578"
              stroke="#1A1A1A"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </div>

        <!-- input cabang -->
        <div style="position: relative" class="keterangan">
          <div
            @click="openClosePilihanCabangPresensi(true)"
            class="box-form email"
          >
            <svg
              width="14"
              height="18"
              viewBox="0 0 14 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M13.4284 7.57115C13.4284 12.5712 6.99986 16.8569 6.99986 16.8569C6.99986 16.8569 0.571289 12.5712 0.571289 7.57115C0.571289 5.86619 1.24858 4.23105 2.45417 3.02546C3.65976 1.81987 5.2949 1.14258 6.99986 1.14258C8.70482 1.14258 10.34 1.81987 11.5455 3.02546C12.7511 4.23105 13.4284 5.86619 13.4284 7.57115Z"
                stroke="#A0A3BD"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M6.99986 9.71401C8.18333 9.71401 9.14272 8.75462 9.14272 7.57115C9.14272 6.38768 8.18333 5.42829 6.99986 5.42829C5.81639 5.42829 4.857 6.38768 4.857 7.57115C4.857 8.75462 5.81639 9.71401 6.99986 9.71401Z"
                stroke="#A0A3BD"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>

            <div class="input-and-title">
              <span
                v-if="filterPresensi.cabang"
                style="display: block"
                class="input-title"
                >Cabang</span
              >
              <p>
                {{ filterPresensi.cabang ? filterPresensi.cabang : "Cabang" }}
              </p>
            </div>
          </div>
          <!-- box pilihan keterangan -->
          <div
            style="display: none"
            ref="pilihan-cabang-presensi-mobile"
            class="box-pilihan"
          >
            <p
              :key="cabang"
              v-for="cabang in listPenempatan"
              @click="openClosePilihanCabangPresensi(false, cabang)"
            >
              {{ cabang }}
              <svg
                v-if="cabang === filterPresensi.cabang"
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M15.7142 5.71484L7.85707 13.572L4.28564 10.0006"
                  stroke="#00BA88"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </p>
          </div>
          <!-- end of box pilihan cabang -->
        </div>
        <!-- end of input cabang -->

        <!-- input divisi -->
        <div style="position: relative" class="keterangan">
          <div
            @click="openClosePilihanDivisiPresensi(true)"
            class="box-form email"
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M0.857422 11.5717L8.00028 15.1431L15.1431 11.5717M0.857422 8.00028L8.00028 11.5717L15.1431 8.00028M8.00028 0.857422L0.857422 4.42885L8.00028 8.00028L15.1431 4.42885L8.00028 0.857422Z"
                stroke="#A0A3BD"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>

            <div class="input-and-title">
              <span
                v-if="filterPresensi.divisi"
                style="display: block"
                class="input-title"
                >Divisi</span
              >
              <p>
                {{ filterPresensi.divisi ? filterPresensi.divisi : "Divisi" }}
              </p>
            </div>
          </div>
          <!-- box pilihan divisi -->
          <div
            style="display: none"
            ref="pilihan-divisi-presensi-mobile"
            class="box-pilihan"
          >
            <p
              :key="divisi"
              v-for="divisi in listDivisi.slice(0, -1)"
              @click="openClosePilihanDivisiPresensi(false, divisi)"
            >
              {{ divisi }}
              <svg
                v-if="divisi === filterPresensi.divisi"
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M15.7142 5.71484L7.85707 13.572L4.28564 10.0006"
                  stroke="#00BA88"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </p>
          </div>
          <!-- end of box pilihan divisi -->
        </div>
        <!-- end of input divisi -->

        <!-- input tanggal -->
        <label tabindex="0" for="date-picker-lahir" class="box-form email">
          <svg
            width="14"
            height="16"
            viewBox="0 0 14 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M9.85725 0.857422V3.71456M4.14296 0.857422V3.71456M0.571533 6.57171H13.4287M2.0001 2.28599H12.0001C12.7891 2.28599 13.4287 2.92559 13.4287 3.71456V13.7146C13.4287 14.5035 12.7891 15.1431 12.0001 15.1431H2.0001C1.21113 15.1431 0.571533 14.5035 0.571533 13.7146V3.71456C0.571533 2.92559 1.21113 2.28599 2.0001 2.28599Z"
              stroke="#A0A3BD"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          <div style="position: relative" class="input-and-title">
            <input
              style="width: 200px; height: 50px"
              id="date-picker-lahir"
              class="date-control"
              type="date"
              v-model="filterPresensi.tanggal"
            />
            <p>
              {{ filterPresensi.tanggal ? filterPresensi.tanggal : "Tanggal" }}
            </p>
          </div>
        </label>
        <!-- end of input tanggal -->

        <div class="button-container">
          <button @click="openCloseFilterKehadiran" class="yellow-button">Terapkan</button>
        </div>
      </div>
    </div>
    <!-- end of filter presensi mobile -->

    <!-- filter dan grafik kehadiran karyawan -->
    <div class="filter-dan-grafik-kehadiran">
      <!-- filter -->
      <div class="filter">
        <h5>Filter</h5>
        <!-- input cabang -->
        <div style="position: relative" class="keterangan">
          <div
            @click="openClosePilihanCabangKehadiran(true)"
            class="box-form email"
          >
            <svg
              width="14"
              height="18"
              viewBox="0 0 14 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M13.4284 7.57115C13.4284 12.5712 6.99986 16.8569 6.99986 16.8569C6.99986 16.8569 0.571289 12.5712 0.571289 7.57115C0.571289 5.86619 1.24858 4.23105 2.45417 3.02546C3.65976 1.81987 5.2949 1.14258 6.99986 1.14258C8.70482 1.14258 10.34 1.81987 11.5455 3.02546C12.7511 4.23105 13.4284 5.86619 13.4284 7.57115Z"
                stroke="#A0A3BD"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M6.99986 9.71401C8.18333 9.71401 9.14272 8.75462 9.14272 7.57115C9.14272 6.38768 8.18333 5.42829 6.99986 5.42829C5.81639 5.42829 4.857 6.38768 4.857 7.57115C4.857 8.75462 5.81639 9.71401 6.99986 9.71401Z"
                stroke="#A0A3BD"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>

            <div class="input-and-title">
              <span
                v-if="filterKehadiran.cabang"
                style="display: block"
                class="input-title"
                >Cabang</span
              >
              <p>
                {{ filterKehadiran.cabang ? filterKehadiran.cabang : "Cabang" }}
              </p>
            </div>
          </div>
          <!-- box pilihan keterangan -->
          <div
            style="display: none"
            ref="pilihan-cabang-kehadiran"
            class="box-pilihan"
          >
            <p
              :key="cabang"
              v-for="cabang in listPenempatan"
              @click="openClosePilihanCabangKehadiran(false, cabang)"
            >
              {{ cabang }}
              <svg
                v-if="cabang === filterKehadiran.cabang"
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M15.7142 5.71484L7.85707 13.572L4.28564 10.0006"
                  stroke="#00BA88"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </p>
          </div>
          <!-- end of box pilihan cabang -->
        </div>
        <!-- end of input cabang -->

        <!-- input divisi -->
        <div style="position: relative" class="keterangan">
          <div
            @click="openClosePilihanDivisiKehadiran(true)"
            class="box-form email"
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M0.857422 11.5717L8.00028 15.1431L15.1431 11.5717M0.857422 8.00028L8.00028 11.5717L15.1431 8.00028M8.00028 0.857422L0.857422 4.42885L8.00028 8.00028L15.1431 4.42885L8.00028 0.857422Z"
                stroke="#A0A3BD"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>

            <div class="input-and-title">
              <span
                v-if="filterKehadiran.divisi"
                style="display: block"
                class="input-title"
                >Divisi</span
              >
              <p>
                {{ filterKehadiran.divisi ? filterKehadiran.divisi : "Divisi" }}
              </p>
            </div>
          </div>
          <!-- box pilihan divisi -->
          <div
            style="display: none"
            ref="pilihan-divisi-kehadiran"
            class="box-pilihan"
          >
            <p
              :key="divisi"
              v-for="divisi in listDivisi.slice(0, -1)"
              @click="openClosePilihanDivisiKehadiran(false, divisi)"
            >
              {{ divisi }}
              <svg
                v-if="divisi === filterKehadiran.divisi"
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M15.7142 5.71484L7.85707 13.572L4.28564 10.0006"
                  stroke="#00BA88"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </p>
          </div>
          <!-- end of box pilihan divisi -->
        </div>
        <!-- end of input divisi -->

        <!-- input tanggal -->
        <label tabindex="0" for="date-picker-lahir" class="box-form email">
          <svg
            width="14"
            height="16"
            viewBox="0 0 14 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M9.85725 0.857422V3.71456M4.14296 0.857422V3.71456M0.571533 6.57171H13.4287M2.0001 2.28599H12.0001C12.7891 2.28599 13.4287 2.92559 13.4287 3.71456V13.7146C13.4287 14.5035 12.7891 15.1431 12.0001 15.1431H2.0001C1.21113 15.1431 0.571533 14.5035 0.571533 13.7146V3.71456C0.571533 2.92559 1.21113 2.28599 2.0001 2.28599Z"
              stroke="#A0A3BD"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          <div style="position: relative" class="input-and-title">
            <input
              style="width: 200px; height: 50px"
              id="date-picker-lahir"
              class="date-control"
              type="month"
              v-model="filterKehadiran.bulan"
            />
            <p>
              {{ filterKehadiran.bulan ? filterKehadiran.bulan : "Bulan" }}
            </p>
          </div>
        </label>
        <!-- end of input bulan -->
      </div>
      <!-- end of filter -->
      <div class="grafik-kehadiran">
        <div class="grafik-title">
          <h5>Grafik kehadiran</h5>
          <p>
            <svg
              width="8"
              height="8"
              viewBox="0 0 8 8"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="4" cy="4" r="4" fill="#00BA88" />
            </svg>
            <span>{{ filterKehadiran.cabang }}</span>
          </p>
        </div>
        <GrafikKehadiran
          :divisi="filterKehadiran.divisi"
          :bulan="filterKehadiran.bulan"
          :cabang="filterKehadiran.cabang"
        ></GrafikKehadiran>
      </div>
    </div>
    <!-- filter dan grafik kehadiran karyawan -->

    <!-- grafik kehadiran mobile -->
    <div class="grafik-kehadiran-mobile">
      <div class="grafik-title">
        <!-- judul dan legend -->
        <div class="title-and-legend">
          <h5 style="margin-bottom: 6px">Grafik kehadiran</h5>
          <p>
            <svg
              width="8"
              height="8"
              viewBox="0 0 8 8"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="4" cy="4" r="4" fill="#00BA88" />
            </svg>
            <span>{{ filterKehadiran.cabang }}</span>
          </p>
        </div>
        <!-- end of judul dan legend -->

        <!-- filter button -->
        <svg
          @click="openCloseFilterKehadiran"
          width="20"
          height="19"
          viewBox="0 0 20 19"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M18.5714 1.28564H1.42859L8.28573 9.39422V15.8571L11.7143 17.5714V9.39422L18.5714 1.28564Z"
            stroke="#4E4B66"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
        <!-- end of filter button -->
      </div>
      <GrafikKehadiranMobile
        :divisi="filterKehadiran.divisi"
        :bulan="filterKehadiran.bulan"
        :cabang="filterKehadiran.cabang"
        :pageNumber="pageNumber"
      ></GrafikKehadiranMobile>

      <!-- grafik navigation -->

      <div class="grafik-navigation">
        <svg
          @click="changePageNumber(false)"
          width="8"
          height="13"
          viewBox="0 0 8 13"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M7.41 11.09L2.83 6.5L7.41 1.91L6 0.5L0 6.5L6 12.5L7.41 11.09Z"
            fill="#C2C9D1"
          />
          <path
            d="M7.41 11.09L2.83 6.5L7.41 1.91L6 0.5L0 6.5L6 12.5L7.41 11.09Z"
            fill="black"
            fill-opacity="0.25"
          />
        </svg>

        <svg
          @click="changePageNumber(true)"
          width="8"
          height="13"
          viewBox="0 0 8 13"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0.589966 11.34L5.16997 6.75L0.589966 2.16L1.99997 0.75L7.99997 6.75L1.99997 12.75L0.589966 11.34Z"
            fill="#C2C9D1"
          />
          <path
            d="M0.589966 11.34L5.16997 6.75L0.589966 2.16L1.99997 0.75L7.99997 6.75L1.99997 12.75L0.589966 11.34Z"
            fill="black"
            fill-opacity="0.25"
          />
        </svg>
      </div>
      <!-- end of grafik navigation -->
    </div>
    <!-- end of grafik kehadiran mobile -->

    <!-- filter kehadiran khusus mobile -->
    <div style="bottom: -100%" ref="filter-kehadiran-mobile" class="backdrop">
      <div class="filter-mobile">
        <div class="filter-mobile-title">
          <h5>Filter Grafik Kehadiran</h5>
          <!-- close filter -->
          <svg
            @click="openCloseFilterKehadiran"
            width="10"
            height="10"
            viewBox="0 0 10 10"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M9.28566 0.714355L0.714233 9.28578M0.714233 0.714355L9.28566 9.28578"
              stroke="#1A1A1A"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </div>

        <!-- input cabang -->
        <div style="position: relative" class="keterangan">
          <div
            @click="openClosePilihanCabangKehadiran(true)"
            class="box-form email"
          >
            <svg
              width="14"
              height="18"
              viewBox="0 0 14 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M13.4284 7.57115C13.4284 12.5712 6.99986 16.8569 6.99986 16.8569C6.99986 16.8569 0.571289 12.5712 0.571289 7.57115C0.571289 5.86619 1.24858 4.23105 2.45417 3.02546C3.65976 1.81987 5.2949 1.14258 6.99986 1.14258C8.70482 1.14258 10.34 1.81987 11.5455 3.02546C12.7511 4.23105 13.4284 5.86619 13.4284 7.57115Z"
                stroke="#A0A3BD"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M6.99986 9.71401C8.18333 9.71401 9.14272 8.75462 9.14272 7.57115C9.14272 6.38768 8.18333 5.42829 6.99986 5.42829C5.81639 5.42829 4.857 6.38768 4.857 7.57115C4.857 8.75462 5.81639 9.71401 6.99986 9.71401Z"
                stroke="#A0A3BD"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>

            <div class="input-and-title">
              <span
                v-if="filterKehadiran.cabang"
                style="display: block"
                class="input-title"
                >Cabang</span
              >
              <p>
                {{ filterKehadiran.cabang ? filterKehadiran.cabang : "Cabang" }}
              </p>
            </div>
          </div>
          <!-- box pilihan keterangan -->
          <div
            style="display: none"
            ref="pilihan-cabang-kehadiran-mobile"
            class="box-pilihan"
          >
            <p
              :key="cabang"
              v-for="cabang in listPenempatan"
              @click="openClosePilihanCabangKehadiran(false, cabang)"
            >
              {{ cabang }}
              <svg
                v-if="cabang === filterKehadiran.cabang"
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M15.7142 5.71484L7.85707 13.572L4.28564 10.0006"
                  stroke="#00BA88"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </p>
          </div>
          <!-- end of box pilihan cabang -->
        </div>
        <!-- end of input cabang -->

        <!-- input divisi -->
        <div style="position: relative" class="keterangan">
          <div
            @click="openClosePilihanDivisiKehadiran(true)"
            class="box-form email"
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M0.857422 11.5717L8.00028 15.1431L15.1431 11.5717M0.857422 8.00028L8.00028 11.5717L15.1431 8.00028M8.00028 0.857422L0.857422 4.42885L8.00028 8.00028L15.1431 4.42885L8.00028 0.857422Z"
                stroke="#A0A3BD"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>

            <div class="input-and-title">
              <span
                v-if="filterKehadiran.divisi"
                style="display: block"
                class="input-title"
                >Divisi</span
              >
              <p>
                {{ filterKehadiran.divisi ? filterKehadiran.divisi : "Divisi" }}
              </p>
            </div>
          </div>
          <!-- box pilihan divisi -->
          <div
            style="display: none"
            ref="pilihan-divisi-kehadiran-mobile"
            class="box-pilihan"
          >
            <p
              :key="divisi"
              v-for="divisi in listDivisi.slice(0, -1)"
              @click="openClosePilihanDivisiKehadiran(false, divisi)"
            >
              {{ divisi }}
              <svg
                v-if="divisi === filterKehadiran.divisi"
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M15.7142 5.71484L7.85707 13.572L4.28564 10.0006"
                  stroke="#00BA88"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </p>
          </div>
          <!-- end of box pilihan divisi -->
        </div>
        <!-- end of input divisi -->

        <!-- input tanggal -->
        <label tabindex="0" for="date-picker-lahir" class="box-form email">
          <svg
            width="14"
            height="16"
            viewBox="0 0 14 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M9.85725 0.857422V3.71456M4.14296 0.857422V3.71456M0.571533 6.57171H13.4287M2.0001 2.28599H12.0001C12.7891 2.28599 13.4287 2.92559 13.4287 3.71456V13.7146C13.4287 14.5035 12.7891 15.1431 12.0001 15.1431H2.0001C1.21113 15.1431 0.571533 14.5035 0.571533 13.7146V3.71456C0.571533 2.92559 1.21113 2.28599 2.0001 2.28599Z"
              stroke="#A0A3BD"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          <div style="position: relative" class="input-and-title">
            <input
              style="width: 200px; height: 50px"
              id="date-picker-lahir"
              class="date-control"
              type="month"
              v-model="filterKehadiran.bulan"
            />
            <p>
              {{ filterKehadiran.bulan ? filterKehadiran.bulan : "Bulan" }}
            </p>
          </div>
        </label>
        <!-- end of input tanggal -->

        <div class="button-container">
          <button @click="openCloseFilterKehadiran" class="yellow-button">Terapkan</button>
        </div>
      </div>
    </div>
    <!-- end of filter kehadiran mobile -->
    <h3 class="judul-tabel-dashboard-ceo">Tabel Rekap Presensi</h3>
    <!-- rekap presensi -->
    <RekapPresensi />
    <!-- end of rekap presensi -->
  </section>
  <!-- end of main view halaman -->
</template>

<script>
import { mapState } from "vuex";
import GrafikPresensi from "@/components/ceo/hrd/grafik/GrafikPresensi";
import GrafikKehadiran from "@/components/ceo/hrd/grafik/GrafikKehadiran";
import GrafikKehadiranMobile from "@/components/ceo/hrd/grafik/GrafikKehadiranMobile";
import RekapPresensi from "@/components/ceo/hrd/RekapPresensi";

export default {
  components: {
    GrafikPresensi,
    GrafikKehadiran,
    GrafikKehadiranMobile,
    RekapPresensi,
  },

  data() {
    return {
      // khusus arus kas mobile
      pageNumber: 1,
      // data untuk filter presensi
      filterPresensi: {
        cabang: "",
        divisi: "humanResource",
        tanggal: new Date().toISOString().slice(0, 10),
      },
      // data untuk filter kehadiran
      filterKehadiran: {
        cabang: "",
        divisi: "humanResource",
        bulan: new Date().toISOString().slice(0, 7),
      },
    };
  },

  methods: {
    // untuk tutup atau buku box pilihan
    openClosePilihanCabangPresensi(open, value) {
      let box = this.$refs["pilihan-cabang-presensi"];
      let boxMobile = this.$refs["pilihan-cabang-presensi-mobile"];
      if (open) {
        box.style.display = "block";
        boxMobile.style.display = "block";
      } else {
        this.filterPresensi.cabang = value;
        box.style.display = "none";
        boxMobile.style.display = "block";
      }
    },

    openClosePilihanDivisiPresensi(open, value) {
      let box = this.$refs["pilihan-divisi-presensi"];
      let boxMobile = this.$refs["pilihan-divisi-presensi-mobile"];
      if (open) {
        box.style.display = "block";
        boxMobile.style.display = "block";
      } else {
        this.filterPresensi.divisi = value;
        box.style.display = "none";
        boxMobile.style.display = "none";
      }
    },

    openClosePilihanCabangKehadiran(open, value) {
      let box = this.$refs["pilihan-cabang-kehadiran"];
      let boxMobile = this.$refs["pilihan-cabang-kehadiran-mobile"];
      if (open) {
        box.style.display = "block";
        boxMobile.style.display = "block";
      } else {
        this.filterKehadiran.cabang = value;
        box.style.display = "none";
        boxMobile.style.display = "none";
      }
    },

    openClosePilihanDivisiKehadiran(open, value) {
      let box = this.$refs["pilihan-divisi-kehadiran"];
      let boxMobile = this.$refs["pilihan-divisi-kehadiran-mobile"];
      if (open) {
        box.style.display = "block";
        boxMobile.style.display = "block";
      } else {
        this.filterKehadiran.divisi = value;
        box.style.display = "none";
        boxMobile.style.display = "none";
      }
    },

    // untuk filter mobile
    openCloseFilterPresensi() {
      let box = this.$refs["filter-presensi-mobile"];
      if (box.style.bottom === "0px") {
        box.style.bottom = "-100%";
      } else box.style.bottom = "0px";
    },

    openCloseFilterKehadiran() {
      let box = this.$refs["filter-kehadiran-mobile"];
      if (box.style.bottom === "0px") {
        box.style.bottom = "-100%";
      } else box.style.bottom = "0px";
    },

    changePageNumber(isIncrease) {
      if (isIncrease) {
        if (this.pageNumber === 3) this.pageNumber = 1;
        else this.pageNumber++;
      } else {
        if (this.pageNumber === 1) this.pageNumber = 3;
        else this.pageNumber--;
      }
    },
  },

  computed: {
    ...mapState(["listPenempatan", "listDivisi"]),
  },
};
</script>

<style scoped>
.filter-pilihan {
  position: relative;
}

.filter {
  display: flex;
  flex-direction: column;
}
</style>
